import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
export function CTASection() {
  return <section id="precio" className="bg-gradient-to-b from-slate-900 to-slate-800 py-24 px-4 text-center" data-id="element-17">
      <div className="max-w-4xl mx-auto bg-gradient-to-br from-amber-500/10 to-purple-900/10 rounded-3xl p-8 md:p-16 border border-amber-500/20 shadow-2xl relative overflow-hidden" data-id="element-18">
        {/* Glow effect */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-amber-500/5 blur-3xl rounded-full pointer-events-none" data-id="element-19"></div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative z-10" data-id="element-20">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-8 font-serif" data-id="element-21">
            Hoy puedes elegir
          </h2>

          <p className="text-xl md:text-2xl text-slate-300 mb-10 max-w-2xl mx-auto" data-id="element-22">
            Pasar otra noche en vela mirando el reloj... o empezar tu camino
            hacia el descanso profundo.
          </p>

          <div className="flex flex-col items-center justify-center mb-10" data-id="element-23">
            <span className="text-slate-400 text-lg mb-2 line-through" data-id="element-24">
              $47 USD
            </span>
            <div className="flex items-baseline gap-2" data-id="element-25">
              <span className="text-2xl text-slate-200" data-id="element-26">Por solo</span>
              <span className="text-6xl font-bold text-amber-400" data-id="element-27">6.36$</span>
              <span className="text-2xl text-slate-200" data-id="element-28">USD</span>
            </div>
          </div>

          <a href="https://relaxofertas.com/cart/42179183738965:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto inline-flex" data-id="element-29">
            <button className="w-full md:w-auto bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold text-xl md:text-2xl py-6 px-12 rounded-xl shadow-[0_0_30px_rgba(245,158,11,0.4)] hover:shadow-[0_0_50px_rgba(245,158,11,0.6)] transition-all transform hover:-translate-y-1 flex items-center justify-center gap-3 group animate-pulse-slow" data-id="element-30">
              ¡QUIERO DORMIR PROFUNDO HOY!
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-31" />
            </button>
          </a>

          <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-4 text-slate-400 text-sm" data-id="element-32">
            <div className="flex items-center gap-2" data-id="element-33">
              <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-34" />
              <span data-id="element-35">Acceso Inmediato Digital</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-36">
              <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-37" />
              <span data-id="element-38">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-39">
              <CheckCircle2 className="w-4 h-4 text-green-500" data-id="element-40" />
              <span data-id="element-41">Garantía de Satisfacción</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}